/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ValidationProblemSeverity } from '../models/ValidationProblemSeverity';
import { IValidationSeverityRegistry } from './IValidationSeverityRegistry';
import { ValidationRuleMetaData } from './ValidationRuleMetaData';

/**
 * A default severity registry.  Sets all spec-mandated validation rules to "medium" severity.  All
 * other rules are ignored.
 * 
 * @author eric.wittmann@gmail.com
 * @class
 */
export class DefaultSeverityRegistry implements IValidationSeverityRegistry {
    /**
     * @see io.apicurio.datamodels.core.validation.IValidationSeverityRegistry#lookupSeverity(io.apicurio.datamodels.core.validation.ValidationRuleMetaData)
     * @param {ValidationRuleMetaData} rule
     * @return {ValidationProblemSeverity}
     */
    public lookupSeverity(rule : ValidationRuleMetaData) : ValidationProblemSeverity {
        if(rule.specMandated) {
            return ValidationProblemSeverity.medium;
        }
        return ValidationProblemSeverity.ignore;
    }

    constructor() {
    }
}
DefaultSeverityRegistry["__class"] = "io.apicurio.datamodels.core.validation.DefaultSeverityRegistry";
DefaultSeverityRegistry["__interfaces"] = ["io.apicurio.datamodels.core.validation.IValidationSeverityRegistry"];




